import TerrainTypes from '@/models/TerrainTypes';

export default [
  {
    name: 'Britain and Belgica',
    terrain: [
      { type: TerrainTypes.Hills, value: [3, 4] },
      { type: TerrainTypes.Woods, value: [4, 5] },
      { type: TerrainTypes.Marsh, value: [2, 3] },
      { type: TerrainTypes.Habitation, value: [1, 2] },
      { type: TerrainTypes.RiverCrossing, value: ['Ford'] },
    ]
  },
  {
    name: 'Gaul',
    terrain: [
      { type: TerrainTypes.Hills, value: [2, 3] },
      { type: TerrainTypes.Woods, value: [3, 4] },
      { type: TerrainTypes.Marsh, value: [1, 2] },
      { type: TerrainTypes.Habitation, value: [2, 3] },
      { type: TerrainTypes.RiverCrossing, value: ['Ford', 'Bridge'] },
    ]
  },
  {
    name: 'Germania',
    terrain: [
      { type: TerrainTypes.Hills, value: [3, 4] },
      { type: TerrainTypes.Woods, value: [6, 7] },
      { type: TerrainTypes.Marsh, value: [3, 4] },
      { type: TerrainTypes.Habitation, value: [0, 1] },
      { type: TerrainTypes.RiverCrossing, value: ['Ford'] },
    ]
  },
  {
    name: 'Italia & Narbonensis',
    terrain: [
      { type: TerrainTypes.Hills, value: [3, 4] },
      { type: TerrainTypes.Woods, value: [1, 2] },
      { type: TerrainTypes.Marsh, value: [1, 2] },
      { type: TerrainTypes.Habitation, value: [2, 3] },
      { type: TerrainTypes.RiverCrossing, value: ['Ford', 'Bridge'] },
    ]
  },
];
